/**
 * The extensions each upload path takes, read from constants/uploads.json - the rules the backend
 * applies (`common/uploads.py`). A file picker that reads them offers exactly these, so it can
 * neither offer a format the upload refuses nor leave out one it takes when the JSON gains a format.
 */
var uploads = require("../constants/uploads.json")

/** `{ <kind>: [".pdf", ".fdx", ...] }`: each kind's formats in the JSON's order, each format's extensions, lower case with a dot. */
var UPLOAD_EXTENSIONS = {}
Object.keys(uploads.kinds).forEach(function (kind) {
  var extensions = []
  uploads.kinds[kind].formats.forEach(function (format) {
    uploads.formats[format].extensions.forEach(function (extension) {
      extensions.push("." + extension.toLowerCase())
    })
  })
  UPLOAD_EXTENSIONS[kind] = extensions
})

module.exports = {
  UPLOAD_EXTENSIONS,
}
